import _ from 'lodash'
import Icon from '../icon'
import { getParentByName } from '../../core/utils/KVdom'
import Tooltip from '../tooltip'

/**
 * mixin for
 *  1 render title
 */
export default {
  inject: ['menu'],
  props: {
    icon: {
      type: String,
      default: null,
    },
    activeTooltipTheme: {
      type: String,
      default: null,
    },
    activeTooltipType: {
      type: String,
      default: 'primary',
    },
    defaultTooltipTheme: {
      type: String,
      default: null,
    },
    defaultTooltipType: {
      type: String,
      default: 'light',
    },
  },
  data() {
    return {
      isSubMenu: false,
    }
  },
  computed: {
    parent() {
      let parent = getParentByName(this, 'KSubMenu')
      if (!parent) {
        parent = getParentByName(this, 'KMenu')
      }
      if (!parent && this.showSubMenuInPopper) {
        parent = getParentByName(this, 'KPopover')
      }

      return parent
    },
    mode() {
      return this.menu.innerMode
    },
    collapsed() {
      return this.menu.collapsed
    },
    showSubMenuInPopper() {
      return this.mode === 'popper'
    },
    shouldRenderItemPopper() {
      return this.collapsed && this.level === 0 && !this.isSubMenu
    },
    level() {
      let level = 0
      let stop = false
      let parent = this.$parent

      while (!stop) {
        if (!parent) {
          stop = true
          break
        }

        if (parent.$options && parent.$options.name === 'KMenu') {
          stop = true
          break
        }

        if (parent.$options && parent.$options.name === 'KSubMenu') {
          level = level + 1
        }

        parent = parent.$parent
      }

      return level
    },
    isTopLevel() {
      return this.level === 0
    },
    indent() {
      if (this.showSubMenuInPopper) {
        return 24
      }
      return 24 + this.level * 24 + 'px'
    },
  },
  watch: {},
  created() {
    this.parent.addItem(this)
  },
  mounted() {
  },
  destroyed() {
    this.parent.removeItem(this)
  },
  methods: {
    handleTitleClick() {
      console.log('mixin api, should rewrite this function by component itself')
    },
    renderIcon() {
      if (this.$slots.icon) {
        return (
          <span class="km-menu__icon">{this.$slots.icon}</span>
        )
      }

      if (this.icon) {
        return (
          <Icon
            class="km-menu__icon"
            fixedWidth={true}
            name={this.icon}
          ></Icon>
        )
      }
    },
    renderInnerTitle() {
      if (this.collapsed && this.level === 0) {
        if (this.isSubMenu) {
          return null
        }

        return (
          <div
            slot="content"
          >
            {this.$slots.default}
          </div>
        )
      }

      if (this.isSubMenu) {
        return (
          <div class="km-menu__title-inner">
            {this.$slots.title}
            <span class="is-pad"></span>
            {this.renderToggle()}
          </div>
        )
      }

      return this.$slots.default
    },
    renderTitle() {
      const style = {
        paddingLeft: this.indent,
      }

      const css = {
        'km-menu__title': true,
        'is-submenu': this.isSubMenu,
      }

      const attrs = {
        ...this.$attrs,
        disabled: this.disabled,
      }

      const events = {
        click: this.handleTitleClick,
      }
      const nativeEvents = {}

      const props = {}
      if (!this.isSubMenu && this.to) {
        props.to = this.to
        nativeEvents.click = this.handleTitleClick
      } else {
        events.click = this.handleTitleClick
      }

      const data = {
        style: style,
        class: css,
        attrs,
        props,
        on: events,
      }

      if (this.isSubMenu && this.showSubMenuInPopper) {
        data.slot = 'reference'
      }

      let tag = 'a'
      if (this.to) {
        tag = 'router-link'
        _.assign(data, { nativeOn: nativeEvents })
      }

      if (this.shouldRenderItemPopper) {
        const tooltipData = {
          props: {
            placement: 'right',
            type: this.active ? this.activeTooltipType : this.defaultTooltipType,
          },
        }
        const tooltipTheme = this.active ? this.activeTooltipTheme : this.defaultTooltipTheme
        if (tooltipTheme) {
          tooltipData.props[tooltipTheme] = true
        }

        return (
          <Tooltip
            {...tooltipData}
          >
            <tag {...data}>
              {this.renderIcon()}
            </tag>
            {this.renderInnerTitle()}
          </Tooltip>
        )
      }

      return (
        <tag {...data}>
          {this.renderIcon()}
          {this.renderInnerTitle()}
        </tag>
      )
    },
  },
  render() {
    const style = {}

    const css = {
      'km-menu__item': true,
    }

    const attrs = {
      'menu-level': this.level,
    }

    const props = {}

    const events = {}

    const data = _.merge({
      style: style,
      class: css,
      attrs: attrs,
      props: props,
      on: events,
    }, { ...this.getRenderData() })

    if (this.isSubMenu && this.showSubMenuInPopper) {
      return (
        <div
          {...data}
        >
          {this.renderPopperSubMenu()}
        </div>
      )
    }

    return (
      <div
        {...data}
      >
        {this.renderTitle()}
        {this.isSubMenu ? this.renderSubMenu() : null}
      </div>
    )
  },
}
